import { forwardRef } from 'react';
import { PopoverContentProps } from '@radix-ui/react-popover';
import { ScrollArea, StyledContent } from '../popover.styled';

import { Arrow } from './arrow';

type Props = PopoverContentProps & {
  withArrow?: boolean;
};

export const Content = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { children, withArrow = true, ...rest } = props;

  return (
    <StyledContent
      ref={ref}
      sideOffset={8}
      collisionPadding={8}
      arrowPadding={24}
      {...rest}
    >
      <ScrollArea>{children}</ScrollArea>
      {withArrow && <Arrow />}
    </StyledContent>
  );
});
